import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { DateUtil } from '../../ui/DateUtil';

@Component({
  selector: 'app-form-yesnodatetime-field',
  templateUrl: './form-yesnodatetime-field.component.html',
  styleUrl: './form-yesnodatetime-field.component.scss'
})
export class FormYesnodatetimeFieldComponent extends FieldType {

  value = "";

  ngOnInit(): void {
    this.value=DateUtil.getYesNoDateTimeFormat(this.formControl.value);
  }


}
